<script lang="ts">import { goto } from "$app/navigation";
import CasinoTopCard from "./casino-top-card.svelte";
import { cfgBrandTitle } from "@infinitro/config";
import { locale, t, Verbiage } from "@infinitro/content";
import { resolvePromotionDescriptionDisplay } from "@infinitro/promotions";
import { formatWithHighlight, loggedIn, ModalDialog, refreshVipState, stateOpenModal, stateRaces, stateVipState, toSiteUrl } from "@infinitro/global";
export let config;
const REWARD_CARD_TYPE_BY_ID = {
	"daily-bonus": "CASHBACK_DAILY",
	"weekly-bonus": "CASHBACK_WEEKLY",
	"monthly-bonus": "CASHBACK_MONTHLY",
	rakeback: "RAKEBACK",
	"level-up": "LEVEL_UP"
};
$: hasActiveRaces = (() => {
	if (config.id !== "flush-races" && config.id !== "weekly-races") return true;
	const races = $stateRaces ?? [];
	if (races.length === 0) {
		return false;
	}
	const now = new Date();
	const result = races.some((race) => {
		const startDate = new Date(race.startDate);
		const endDate = new Date(race.endDate);
		const isActive = now >= startDate && now <= endDate && race.active;
		return isActive;
	});
	return result;
})();
$: determineSoonState = (() => {
	if ((config.id === "flush-races" || config.id === "weekly-races") && !hasActiveRaces) return true;
	if (!config.conditionalButton || !config.startDate) return false;
	const now = new Date().getTime();
	const startTime = config.startDate.getTime();
	switch (config.conditionalButton.condition) {
		case "beforeStart": return now < startTime;
		case "afterStart": return now < startTime;
		case "betweenDates":
			if (config.endDate) {
				const endTime = config.endDate.getTime();
				return now < startTime || now > endTime;
			}
			return now < startTime;
		case "custom": return config.conditionalButton.customCondition?.() ?? false;
		default: return false;
	}
})();
const hasRewardClaimReady = (rewardType, vipState) => {
	return vipState?.rewards?.some((reward) => reward.rewardType === rewardType && reward.claimReady === true) ?? false;
};
const getRewardDestination = () => $loggedIn === true ? "/vip-dashboard/" : "/vip/";
$: rewardType = REWARD_CARD_TYPE_BY_ID[config.id];
$: isRewardCard = !!rewardType;
$: rewardClaimReady = isRewardCard && $loggedIn === true ? hasRewardClaimReady(rewardType, $stateVipState) : false;
const handleRewardAction = async () => {
	if (!isRewardCard) return;
	if ($loggedIn !== true) {
		await goto(toSiteUrl("/vip/", false));
		return;
	}
	// Use current VIP snapshot first for instant dropdown opening.
	if (rewardClaimReady) {
		stateOpenModal.set(ModalDialog.RewardsDropdown);
		return;
	}
	// If rewards are not loaded yet, refresh once and retry.
	if (!Array.isArray($stateVipState?.rewards)) {
		await refreshVipState();
		if (hasRewardClaimReady(rewardType, $stateVipState)) {
			stateOpenModal.set(ModalDialog.RewardsDropdown);
			return;
		}
	}
	await goto(toSiteUrl("/vip-dashboard/", true));
};
$: buttonText = (() => {
	if (isRewardCard) {
		return $t(rewardClaimReady ? Verbiage.claim_now : Verbiage.more_info);
	}
	if (!config.conditionalButton) {
		return $t(config.buttonText);
	}
	const text = determineSoonState ? config.conditionalButton.inactiveText : config.conditionalButton.activeText;
	return $t(text);
})();
$: link = isRewardCard ? getRewardDestination() : config.conditionalLink ? $loggedIn === true ? config.conditionalLink.loggedInLink : config.conditionalLink.loggedOutLink : config.link;
$: titleSingleLine = Reflect.get(config, "titleSingleLine") === true;
$: title = $t(config.title)?.replace("[BRAND]", cfgBrandTitle());
$: description = (() => {
	const raw = resolvePromotionDescriptionDisplay(config, $locale, $t);
	return config.formatDescription ? formatWithHighlight(raw) : raw;
})();
$: multiLineDescriptionResolved = config.multiLineDescription === true || description.includes("\n") || description.includes("\\n");
$: badgeText = config.badgeText ? $t(config.badgeText) : undefined;
$: amountBoxText = config.amountBox?.text ? $t(config.amountBox.text) : undefined;
</script>

<CasinoTopCard
	backgroundImage={config.backgroundImage}
	image={config.image}
	{title}
	{description}
	{badgeText}
	{buttonText}
	{link}
	soon={determineSoonState}
	imageStyles={config.imageStyles}
	multiLineDescription={multiLineDescriptionResolved}
	titleAllHighlighted={config.titleAllHighlighted}
	customDescriptionWidth={config.customDescriptionWidth}
	customTitleWidth={config.customTitleWidth}
	requireLogIn={config.requireLogIn}
	{titleSingleLine}
	{amountBoxText}
	amountBoxColor={config.amountBox?.color}
	amountBoxTextColor={config.amountBox?.textColor}
	onActionClick={isRewardCard ? handleRewardAction : undefined}
/>

<style>
</style>
